import { BuildType } from '@/services/ApiService';
import { ProgramsResponse, ProgramTypeModel, QueryProgramParams, UserProgramModel } from '@/types/Program';
import { ProgramModel } from '@/types/Program';

export const programApiEndpoints = (build: BuildType) => ({
    programs: build.query<ProgramsResponse, QueryProgramParams>({
        query: params => ({
            url: 'programs/query',
            method: 'POST',
            body: params,
        }),
        transformResponse: (response: ProgramsResponse) => response,
        providesTags: ['Programs'],
    }),
    getProgramTypes: build.query<ProgramTypeModel[], void>({
        query: () => 'program-types',
    }),
    programDetails: build.query<ProgramModel, string>({
        query: id => `programs/${id}`,
    }),
    favoriteProgram: build.mutation<void, string>({
        query: programId => ({
            url: `user-programs/${programId}/favorite`,
            method: 'POST',
        }),
        invalidatesTags: ['Favorites', 'UserPrograms', 'Programs'],
    }),
    getFavoritePrograms: build.query<UserProgramModel[], void>({
        query: () => 'user-programs/favorites',
        providesTags: ['UserPrograms'],
    }),
});
